import type {JSX} from 'react'

import AdminProducts from "./admin/AdminProducts";
import {AdminUsers} from "./admin/AdminUsers";

export default function Admin(): JSX.Element {
  return (
    <div className='container'>
      <AdminProducts/>
      <AdminUsers/>
    </div>
  )
}
